import React, { Component } from "react";
import algoliasearch from "algoliasearch/lite";
import {
    InstantSearch,
    SearchBox,
    connectStats,
    connectStateResults,
} from "react-instantsearch-dom";
import { enquireScreen } from "enquire-js";
import { Box, Flex, Text, Spinner } from "theme-ui";
import CardView from "./CardView";
import CompletenessView from "./completeness";

const searchClient = algoliasearch(
  "2S9KBQSQ3L",
  "1aeb416dedd122b926b314c930f51dc0"
);

const CountComponent = ({ nbHits }) => <Text> {nbHits} Total</Text>;
const HitsCount = connectStats(CountComponent);

const StateResults = ({ searching }) => {
  
  if (searching) {
    return (
      <Flex sx={{
        justifyContent: "center",
      }}>
        <Spinner variant="styles.spinner" />
      </Flex>
    );
  }
  return null;
};

const Loader = connectStateResults(StateResults);

class Search extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewType: "Summary",
      isMobile: false,
    };
  }

    componentDidMount() {
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

  handleResize = () => {
    let resize = false;
    enquireScreen(b => {
      resize = b;
    });
    this.setState({ isMobile: resize });
  };

    changeView(view) {
        this.setState({ viewType: view });
    }

    render() {
        const { isMobile, viewType } = this.state;
        return (
            <>
                {/* <ExpertImg /> */}
                <Box sx={{ marginTop: "80px" }}>
                    <InstantSearch
                        indexName={`${process.env.GATSBY_ALGOLIA_PACK_INDEX}`}
                        searchClient={searchClient}
                    >
                        {isMobile ? <Flex
                            sx={{
                                backgroundColor: "#FFFFFF",
                                border: "1px solid #D9D9D9",
                                flexDirection: "column",
                                borderRadius: "8px 8px 0px 0px",
                                padding: "16px",
                                rowGap: "5px"
                            }}
                        >
                            <Box>
                                <Text sx={{ fontSize: ["14px", "16px"], fontWeight: "600" }}>
                                    Packages: &nbsp;&nbsp;
                                </Text>
                                <HitsCount />
                            </Box>
                            <Box
                                sx={{
                                    flexGrow: 1,
                                    height: "32px",
                                }}
                            >
                                <SearchBox
                                    className="expec-list-search"
                                    sx={{ height: "30px" }}
                                />
                            </Box>
                        </Flex> :
                            <Flex
                                sx={{
                                    alignItems: "center",
                                    backgroundColor: "#FFFFFF",
                                    border: "1px solid #D9D9D9",
                                    borderRadius: "8px 8px 0px 0px",
                                    height: "64px",
                                    padding: "16px",
                                    columnGap: "5px"
                                }}
                            >
                                <Box>
                                    <Text sx={{ fontSize: ["14px", "16px"], fontWeight: "600" }}>
                                        Packages: &nbsp;&nbsp;
                                    </Text>
                                    <HitsCount />
                                </Box>
                                <Box
                                    sx={{
                                        flexGrow: 1,
                                        height: "32px",
                                        marginLeft: "auto",
                                    }}
                                >
                                    <SearchBox
                                        className="expec-list-search"
                                        sx={{ height: "30px", width: "100%" }}
                                    />
                                </Box>
                                <Flex sx={{ border: "1px solid #D9D9D9", borderRadius: "4px" }}>
                                    <Box
                                        sx={{ p: "4px 16px", cursor: "pointer" }}
                                        onClick={() => this.changeView("Summary")}
                                        className={
                                            viewType === "Summary" ? "highlight" : ""
                                        }
                                    >
                                        Summary
                                    </Box>
                                    <Box
                                        sx={{ p: "4px 16px", cursor: "pointer" }}
                                        onClick={() => this.changeView("Completeness")}
                                        className={
                                            viewType === "Completeness" ? "highlight" : ""
                                        }
                                    >
                                        Completeness
                                    </Box>
                                    {/* <Box sx={{p: "4px 16px", cursor: "pointer" }} onClick={(e) => this.changeView("Datasource")} className={viewType=="Datasource" ? "highlight" : ""}>
                Datasource
              </Box> */}
                                </Flex>
                            </Flex>}
                        <Loader />
                        {
                            (() => {
                                if (viewType === "Summary") return <CardView screenSize={isMobile} version={this.props.version}/>;
                                if (viewType === "Completeness") return <CompletenessView />;
                                return null;
                            })()
                        }
                        {/* <Box p="12px">
                            <Paragraph>
                                Can&apos;t find the Expectation you need?
                                <Link
                                    sx={{ variant: "links.green", ml: "5px" }}
                                    to="https://docs.greatexpectations.io/docs/guides/expectations/creating_custom_expectations/overview/"
                                >
                                    Learn how to create an Expectation here
                                </Link>
                            </Paragraph>
                        </Box> */}
                    </InstantSearch>
                </Box>
            </>
        );
    }
}

export default Search;
